import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import Brand from "@/types/brand";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface BrandInfo {
  brand: Brand;
}

@Module
export default class BrandModule extends VuexModule implements BrandInfo {
  brand = {} as Brand;

  @Mutation
  [Mutations.SET_BRAND](brand) {
    this.brand = brand;
  }

  @Action
  [Actions.BRAND_LIST]() {
    return ApiService.get("brand")
      .then(({ data }) => {
        this.context.commit(Mutations.SET_BRAND, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.ADD_BRAND](args) {
    return ApiService.post("brand", args).then(({ data }) => {
      if (!data.success) {
        return data;
      } else {
        //this.context.commit(Mutations.SET_SIZE_SET, data);
        return data;
      }
    });
  }

  @Action
  [Actions.UPDATE_BRAND](args) {
    return ApiService.put("brand", args).then(({ data }) => {
      if (!data.success) {
        return data;
      } else {
        //this.context.commit(Mutations.SET_SIZE_SET, data);
        return data;
      }
    });
  }

  @Action
  [Actions.REMOVE_BRAND](id) {
    return ApiService.delete("brand/" + id + "")
      .then(({ data }) => {
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
        return response;
      });
  }
}
